var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnrecResponses01 = function SvgUnrecResponses01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "unrec_responses-01_svg2__a",
    x1: 5.26,
    x2: 175.99,
    y1: 181.26,
    y2: 10.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#unrec_responses-01_svg2__a",
    id: "unrec_responses-01_svg2__b",
    x1: 12.52,
    x2: 183.25,
    y1: 188.52,
    y2: 17.79
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#unrec_responses-01_svg2__a",
    id: "unrec_responses-01_svg2__c",
    x1: -19.05,
    x2: 151.68,
    y1: 156.95,
    y2: -13.79
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#unrec_responses-01_svg2__a",
    id: "unrec_responses-01_svg2__d",
    x1: 3.85,
    x2: 174.58,
    y1: 179.85,
    y2: 9.12
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#unrec_responses-01_svg2__a",
    id: "unrec_responses-01_svg2__e",
    x1: 21.94,
    x2: 192.67,
    y1: 197.94,
    y2: 27.21
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#unrec_responses-01_svg2__a",
    id: "unrec_responses-01_svg2__f",
    x1: -4.56,
    x2: 166.17,
    y1: 171.44,
    y2: 0.7
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#unrec_responses-01_svg2__a",
    id: "unrec_responses-01_svg2__g",
    x1: 26.19,
    x2: 196.92,
    y1: 202.19,
    y2: 31.46
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M199.52 72.49 162.43 4.04a4.07 4.07 0 0 0-3.59-2.14c-1.5 0-2.88.83-3.59 2.15l-16.23 30.04H14.25C6.39 34.09 0 40.48 0 48.34v96.75c0 7.86 6.39 14.25 14.25 14.25h20.47l.4 32.64c0 .84.28 1.66.77 2.34a9.16 9.16 0 0 0 7.42 3.78c2.94 0 5.71-1.42 7.2-3.51l30.23-35.25h84.58c7.88 0 14.29-6.39 14.29-14.25V78.52h16.3a4.1 4.1 0 0 0 3.51-1.99c.73-1.24.77-2.77.08-4.04Zm-28.06 72.6c0 3.35-2.75 6.08-6.13 6.08H78.87c-1.19 0-2.33.52-3.1 1.43l-31.66 36.95c-.26.36-.63.41-.83.38l-.42-34.72a4.08 4.08 0 0 0-4.08-4.03H14.25c-3.35 0-6.09-2.73-6.09-6.08V48.34c0-3.36 2.73-6.09 6.09-6.09h120.33l-16.34 30.24a4.08 4.08 0 0 0 .08 4.03 4.08 4.08 0 0 0 3.51 1.99h49.62v66.57Zm-42.77-74.74c29.28-54.16 25.71-47.55 30.16-55.77l30.22 55.77z",
    style: {
      fill: "url(#unrec_responses-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.8 36.55v11.24c0 2.26 1.83 4.08 4.08 4.08s4.08-1.83 4.08-4.08V36.55c0-2.26-1.83-4.08-4.08-4.08s-4.08 1.83-4.08 4.08",
    style: {
      fill: "url(#unrec_responses-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.58 77.62h67.54c2.26 0 4.08-1.83 4.08-4.08s-1.83-4.08-4.08-4.08H30.58c-2.26 0-4.08 1.83-4.08 4.08s1.83 4.08 4.08 4.08",
    style: {
      fill: "url(#unrec_responses-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.49 94.65c0 2.26 1.83 4.08 4.08 4.08h116.94c2.26 0 4.08-1.83 4.08-4.08s-1.83-4.08-4.08-4.08H30.58c-2.26 0-4.08 1.83-4.08 4.08z",
    style: {
      fill: "url(#unrec_responses-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.88 56.74c-2.26 0-4.29 2.01-4.29 4.27s2.03 4.27 4.29 4.27 4.29-2.02 4.29-4.27-2.03-4.27-4.29-4.27",
    style: {
      fill: "url(#unrec_responses-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.34 113.53h-38c-2.21 0-4 1.79-4 4s1.79 4 4 4h38c2.21 0 4-1.79 4-4s-1.79-4-4-4",
    style: {
      fill: "url(#unrec_responses-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.34 113.53h-53c-2.21 0-4 1.79-4 4s1.79 4 4 4h53c2.21 0 4-1.79 4-4s-1.79-4-4-4",
    style: {
      fill: "url(#unrec_responses-01_svg2__g)"
    }
  }));
};
export default SvgUnrecResponses01;